import { render } from "./Input.vue?vue&type=template&id=0fcb4ae6&scoped=true&ts=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=0fcb4ae6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcb4ae6"]])

export default __exports__